function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { styled } from '@mui/material/styles';
export var StyledAlert = styled(Alert)(function (_ref) {
  var theme = _ref.theme,
    color = _ref.color,
    variant = _ref.variant;
  return _extends({
    fontSize: theme.typography.size.scale(4)
  }, (color === 'success' || color === 'warning') && variant === 'filled' && {
    color: theme.palette.success.contrastText
  }, {
    '& .MuiAlert-icon': {
      padding: '9px 0'
    },
    '& .MuiTouchRipple-root': {
      display: 'none'
    }
  });
});
export var StyledAlertTitle = styled(AlertTitle)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    fontSize: theme.typography.size.large,
    fontWeight: theme.typography.fontWeightBold
  };
});